import ChatSDK from 'test-iso-chat-sdk';

export const makeAdmin = async (conversationId, userId) => {
    const response = await ChatSDK.getInstance().Conversation.putConversationAdmin({conversationId: conversationId, memberId: userId});
    return response;
}

export const removeAdmin = async (conversationId, userId) => {
    const response = await ChatSDK.getInstance().Conversation.deleteConversationAdmin({conversationId: conversationId, memberId: userId});
    return response;
}


